import { CanActivateFn } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import {filter, map, switchMap, take, tap} from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Auf Abschluss der Auth0-Initialisierung warten, bevor isAuthenticated
  // ausgewertet wird. Kommt der User aus einem Auth0-Redirect-Flow zurück
  // (z.B. Email-Verify), ist der Callback beim ersten Guard-Lauf noch nicht
  // verarbeitet; ohne dieses Warten würde der initiale Wert false gelesen und
  // der bereits eingeloggte User bliebe fälschlich auf /login hängen. (DOCU-642)
  return auth.isLoading$.pipe(
    filter(isLoading => !isLoading),
    take(1),
    switchMap(() => auth.isAuthenticated$),
    take(1),
    tap(isAuthenticated => {
      // store target URL if not authenticated
      if (!isAuthenticated && state.url !== '/login') {
        sessionStorage.setItem('redirectUrl', state.url);
      }
    }),
    map(isAuthenticated => {
      const isLoginPage = state.url === '/login';

      if (isAuthenticated && isLoginPage) {
        // already logged in → redirect to stored target or dashboard
        const redirectUrl = sessionStorage.getItem('redirectUrl');
        sessionStorage.removeItem('redirectUrl');
        return router.parseUrl(redirectUrl || '/audits');
      }

      if (!isAuthenticated && !isLoginPage) {
        // not logged in → go to login
        return router.createUrlTree(['/login']);
      }

      // otherwise, allow
      return true;
    })
  );
};
